import { render, staticRenderFns } from "./SearchBrandIcon.vue?vue&type=template&id=79043ff6"
import script from "./SearchBrandIcon.vue?vue&type=script&lang=js"
export * from "./SearchBrandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports